export default __webpack_public_path__ + "static/5-2--9734b6b728b33bf2ccbc3be85048454b.png";